import {_hostMedia} from "../redux/api";
import defaultFileLogo from '../assets/images/default.jpg';

export function generateImageMediaUrl(path) {
    if (path?.startsWith('http')) {
        return path;
    }
    let url= path ? `${_hostMedia}/images${path}` : '';

    return url
}

export function generateFileMediaUrl(path) {
    if (path?.startsWith('http')) {
        return path;
    }
    return path ? `${_hostMedia}/resources${path}` : ''
}